export default __webpack_public_path__ + "static/media/access-denied.303c068c.svg";